var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCorporateCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0625 18.7031H3.9375C3.03516 18.7031 2.29688 17.9648 2.29688 17.0625V7.21875C2.29688 6.31641 3.03516 5.57812 3.9375 5.57812H17.0625C17.9648 5.57812 18.7031 6.31641 18.7031 7.21875V17.0625C18.7031 17.9648 17.9648 18.7031 17.0625 18.7031Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98144 10.5384L1.98136 10.5385L1.98667 10.5417C4.61469 12.1119 7.55717 12.9055 10.5 12.9055C13.4428 12.9055 16.3853 12.1119 19.0133 10.5417L19.0134 10.5418L19.0186 10.5384C19.1929 10.4221 19.3203 10.2389 19.3203 10.0078V7.21875C19.3203 5.96846 18.3128 4.96094 17.0625 4.96094H14.0699C14.0702 4.95317 14.0703 4.94535 14.0703 4.9375C14.0703 3.68721 13.0628 2.67969 11.8125 2.67969H9.1875C7.93721 2.67969 6.92969 3.68721 6.92969 4.9375C6.92969 4.94535 6.92982 4.95317 6.9301 4.96094H3.9375C2.68721 4.96094 1.67969 5.96846 1.67969 7.21875V10.0078C1.67969 10.2389 1.80707 10.4221 1.98144 10.5384ZM12.8363 4.96094H8.16365C8.16393 4.95317 8.16406 4.94535 8.16406 4.9375C8.16406 4.36669 8.61669 3.91406 9.1875 3.91406H11.8125C12.3833 3.91406 12.8359 4.36669 12.8359 4.9375C12.8359 4.94535 12.8361 4.95317 12.8363 4.96094ZM18.0859 9.65654C13.3826 12.3426 7.61744 12.3426 2.91406 9.65654V7.21875C2.91406 6.64794 3.36669 6.19531 3.9375 6.19531H17.0625C17.6333 6.19531 18.0859 6.64794 18.0859 7.21875V9.65654Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorporateCustomer);
export default __webpack_public_path__ + "static/media/icon-corporate-customer.ddcd6d21d5c1df1d517db4c9291d5b32.svg";
export { ForwardRef as ReactComponent };